import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Slider from 'react-slick';
import { compose, withProps } from 'recompose';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { Rate, notification } from 'antd';
import { Col, Container, Dropdown, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { LogoWhite, PDFIcon, ProgramLoader, UploadLoader } from '../reuse/SVG';
import { bookingDetailService, programFavourite, followcamps, bookingreview, updateBookingKeyService, cancelProgramBookingByCampers } from '../../services/programService';
import { uploadGardianPdfService } from '../../services/directorServices';
import { getProgramType, gradeArr2, getExperience, getFacility, getTravel, getTshirt, TRAVEL_NEEDS_INFO, campDates, getHtml, removeHtmlTags, getprogramdatesInCartFromFormatted, isNonEmptyArray, isLessThanEquals14Days, getApplicableDocuments } from '../../helper';
import Share from '../static/Share';
import { uploadMedia } from '../../services/campersServices';
import { v4 as uuidv4 } from 'uuid';
import setting from '../../config/settings';
import { Link } from 'react-router-dom';
import buttonGif from '../../assets/img/call-action-button.gif'
import PdfViewer from '../common/PdfViewer/PdfViewer';
import { CancellationPolicyCards } from '../cart/cancellationPolicy/CancellationPolicyModal';
import { useAdditionalExperience } from "../../context/AdditionalExperienceContext";
import { INSURANCE } from '../../Enums/Enum';


const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
};

const settings2 = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
};


const getSelectedDates = (_all, _sel) => {
    const _res = _all.filter(el => _sel.find((id) => el._id === id));
    return _res.map(i => (
        <span className='cm_selected_date' key={i._id}>
            {getprogramdatesInCartFromFormatted(i.startDateFormatted, i.endDateFormatted)}
        </span>
    ));
}

const getProgramPriceByDates = (allPrices, selectedDateByProgram) => {
    const _res = allPrices.filter(el => selectedDateByProgram.find((id) => el._id === id));
    let _totalPrice = 0;
    if (_res.length) {
        _res.map(i => _totalPrice += i.standardPrice)
    }

    if (_totalPrice > 0) {
        return `Price: $${_totalPrice.toFixed(2)}`
    } else {
        return 'Free'
    }
}



const getProgramPriceByDates2 = (allPrices, selectedDateByProgram) => {
    const _res = allPrices.filter(el => selectedDateByProgram.find((id) => el._id === id));
    let _totalPrice = 0;
    if (_res.length) {
        _res.map(i => _totalPrice += i.standardPrice)
    }

    if (_totalPrice > 0) {
        return _totalPrice.toFixed(2)
    } else {
        return 'Free'
    }
}




const MapComponent = compose(
    withProps({
        containerElement: <div style={{ height: `180px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    withGoogleMap
)((props) =>
    <GoogleMap
        defaultZoom={4}
        defaultCenter={{ lng: props.geoLocation ? props.geoLocation[0] : 0, lat: props.geoLocation ? props.geoLocation[1] : 0 }}>
        <Marker
            position={{ lng: props.geoLocation ? props.geoLocation[0] : 0, lat: props.geoLocation ? props.geoLocation[1] : 0 }}
            icon={{
                url: require('../../assets/img/mapIcon.svg')
            }}
        >
        </Marker>
    </GoogleMap>
);

/**
 * The Program Cost line of a camper's breakdown: the tier price alone, so that it plus the
 * separate Non-refundable Fee row below it sum to what was charged.
 *
 * Which of those two the stored `campRegistrationFee` already is depends on who made the booking,
 * because the two checkout paths price with different functions:
 *
 *   - parent self-checkout (`calcCamperWisePrice`) stores the bare tier and charges the fee on
 *     top, so this line is `campRegistrationFee` as stored;
 *   - director-created (`calcPriceCamperWise`) stores `tier + registerNonRefundFee`, so the fee
 *     has to come back out or the parent is billed for it twice on paper.
 *
 * The fee is stored per program but paid per camper, so it is deducted once from each camper's
 * line, matching the per-camper Non-refundable Fee row rendered alongside.
 */
const getProgramCostLine = (camper, bookingDetail) => {
    const campRegistrationFee = camper?.campRegistrationFee || 0;
    if (!bookingDetail?.isDirectorBooking) return campRegistrationFee;
    return Math.max(0, campRegistrationFee - (bookingDetail?.registerNonRefundFee || 0));
};

const ViewBooking = props => {

    let history = useHistory();
    const todayDate = new Date().getTime();

    const [bookingDetail, setBookingDetail] = useState('');
    const [loader, setLoader] = useState(true);
    const [isFavourite, setIsFavourite] = useState('');
    const [pdfLoader, setPdfLoader] = useState('');
    const [isFollowed, setIsFollowed] = useState('');
    const [reviewText, setReviewText] = useState('');
    const [reviewError, setReviewError] = useState(false);
    const [reviewSuccess, setReviewSuccess] = useState(false);
    const [rating, setRating] = useState(5);
    const [cancelModal, setCancelModal] = useState(false);
    const [campers, setCampers] = useState([]);
    const [cancelBookingLoader, setCancelBookingLoader] = useState(false);
    const [selectedCamperForCancelBooking, setSelectedCamperForCancelBooking] = useState([]);
    const [cancelAcknowledged, setCancelAcknowledged] = useState(false);
    const [activeForm, setActiveForm] = useState({});
    const [isViewProducts, setIsViewProducts] = useState(false)
    const [activeProduct, setActiveProduct] = useState('')
    const [productFilter, setProductFilter] = useState(1)
    // const [prodcutsList, setProdcutsList]       = useState([]);
    const [disableDocsUpload, setDisableDocsUpload] = useState(false)

    const { openModal } = useAdditionalExperience();

    const closeModal = () => {
        setCancelModal(false);
        setSelectedCamperForCancelBooking([]);
        setCancelAcknowledged(false);
    }

    const handleAddAdditionalExperience = () => {
        openModal({
            bookingId: props.match.params.id,
            programId: props.match.params.programId
        });
    };

    const getBookingInfo = () => {
        let params = {
            bookingId: props.match.params.id,
            programId: props.match.params.programId
        }
        bookingDetailService(params).then(res => {
            setPdfLoader('')
            if (res?.data?.statusCode) {
                setBookingDetail(res.data.responseData.result);
                setIsFavourite(res.data.responseData.result.isFavourite);
                setIsFollowed(res.data.responseData.result.isFollowed);
                setCampers(res.data.responseData.result.campers);


                setLoader(false);

            } else {
                setLoader(false);
            }
        }).catch(err => {
            setLoader(false);
        })
    }

    useEffect(() => {
        getBookingInfo();
    }, [])



    const updateBookingKey = () => {
        let params = {
            bookingId: props.match.params.id,
            programId: props.match.params.programId,
        }

        if (activeForm.type === 'keyDeposit') {
            params.keyDeposit = true;
            params.camperId = activeForm.camperId;
        } else if (activeForm.type === 'isDisclaimer') {
            params.isDisclaimer = true;
        } else {
            params.concussion = true;
            params.camperId = activeForm.camperId;
        }

        setActiveForm({})
        updateBookingKeyService(params).then(res => {
            if (res?.data?.statusCode) {
                getBookingInfo();
            }
        })
    }



    const handleFavourite = () => {
        setIsFavourite(!isFavourite);
        let params = {
            programId: bookingDetail.programId,
            favourite: !isFavourite
        }
        programFavourite(params).then(res => {

        })
    }


    const handleFollow = () => {
        setIsFollowed(!isFollowed);
        let params = {
            campId: bookingDetail.campId,
            follow: !isFollowed
        }

        followcamps(params).then(res => {

        })
    }

    const submitReview = campId => {
        if (reviewText.trim().length <= 0) {
            setReviewError(true)
        } else {
            let params = {
                "campId": campId,
                "programId": props.match.params.programId,
                "rating": '' + rating,
                "review": reviewText
            }
            bookingreview(params).then(res => {
                if (res?.data?.statusCode) {
                    setReviewSuccess(true);
                    setReviewText('');
                } else {
                    notification.open({
                        description:
                            'Please try after some time',
                    });
                }
            })
        }
    }



    const handleFileUpload = (e, camperId) => {
        setPdfLoader({ [camperId]: true })
        let params = new FormData();
        params.append('bookingId', props.match.params.id);
        params.append('programId', bookingDetail.programId);
        params.append('camperId', camperId);
        params.append('file', e.target.files[0]);

        uploadGardianPdfService(params).then(res => {
            getBookingInfo();
        })


    }


    const handleFileChange = (e, camperId) => {
        if (e.target.files[0]) {
            const data = new FormData();
            data.append('file', e.target.files[0]);
            uploadMedia(data).then((res) => {
                if (res.data.responseData.result.fileUrl) {
                    let params = {
                        bookingId: props.match.params.id,
                        programId: props.match.params.programId,
                        camperId: camperId,
                        medicalDocument: res.data.responseData.result.fileUrl
                    }

                    updateBookingKeyService(params).then(res => {
                        if (res?.data?.statusCode) {
                            getBookingInfo();
                            e.target.value = null;
                        }
                    })
                }
            })
        }

    }




    const handlePrint = e => {
        setTimeout(() => window.print(), 0)
    };


    const handleBookingCancel = () => {
        let _campers = campers.filter(i => selectedCamperForCancelBooking.find(m => m === i.camperId)).map(v => ({ programCost: v.programCost, camperId: v.camperId }));



        let params = {
            bookingId: props.match.params.id,
            programs: [
                {
                    programId: bookingDetail.programId,
                    campers: _campers
                }
            ]
        }
        setCancelBookingLoader(true);
        cancelProgramBookingByCampers(params).then(res => {
            setCancelBookingLoader(false);
            if (res?.data?.statusCode) {
                history.push('/profile/bookings')
                notification.open({
                    message: 'Booking',
                    description:
                        'Booking canceled',
                });
            }
        })
    }


    const handleCancelCamperSelect = id => {
        let temp = [...selectedCamperForCancelBooking]
        if (temp.includes(id)) {
            temp = temp.filter(i => i !== id);
        } else {
            temp.push(id);
        }
        setSelectedCamperForCancelBooking(temp)
    }


    // Registration Protection is the only cancellation cover; it can be bought at checkout or later
    // from the camper page, and either way lands in the camper's insuranceData (not in
    // bookingDetail.insurance, which is the checkout charge and also counts Accident and Injury).
    // Same campers as the cancel list below. A policy only counts once it was paid: like the API's
    // cleanUnpaidInsurances (which the camper page goes through and this endpoint does not), that
    // means an insuranceResponse whose quote and registration match the accepted quote.
    const isPaidPolicy = (ins, responses) => (responses || []).some(r =>
        r?.data?.partner_quote_id === ins.quote_id
        && (r?.data?.metadata?.registrationId === ins.registrationId || r?.registrationId === ins.registrationId));

    const hasCancellationInsurance = arr => (arr || [])
        .filter(c => c.status !== 2 && c.status !== 3)
        .some(c => (c.insuranceData || []).some(ins =>
            ins?.insuranceStatus === 1
            && ins?.product?.name === INSURANCE.REGISTRATION_CANCELLATION_INSURANCE
            && !!ins.quote_id
            && isPaidPolicy(ins, c.insuranceResponse)));

    const checkCancelStatus = arr => {
        if (arr?.length) {
            let _arr = arr.filter(i => i.status === 1);
            if (_arr.length) {
                return true;
            }
            else {
                return false
            }
        }
    }


    const getMedicalDocumentUrl = (data) => {
        if (data.length) {
            let _res = data.filter(i => (i !== ''));
            return _res[0]
        } else {
            return '';
        }

    }
    const showProductInfo = (pp, productDetails = {}) => {
        pp['selectedColor'] = productDetails.color;
        pp['selectedSize'] = productDetails.sizes;
        pp['count'] = productDetails.count;
        pp['selectedPrice'] = productDetails.price;
        setActiveProduct(pp)
        setIsViewProducts(true);
    }
    const handleCloseProductModal = () => {
        setIsViewProducts(false)
    }



    // Per-camper forms follow the program's Super Admin sliders (getApplicableDocuments). A camper's
    // entry also carries its age group, so it shows when either is there.
    const camperHasEntry = item => {
        const applies = getApplicableDocuments(bookingDetail, item);
        const hasAgeGroup = !!(item.camplistid && bookingDetail?.agegroups?.length);
        return applies.keyDeposit || applies.concussion || applies.medicalClearance || hasAgeGroup;
    };
    const showCamperForms = campers.some(camperHasEntry);

    const getAgeGroupsOfBooking = (itemId, groups) => {
        if (itemId && groups.length) {
            let _group = groups.find(i => i.camplistid === itemId);

            return (
                <div>
                    <div><b>Age Group: {_group.age}</b></div>

                    <div className='age_g_days in_booking_detail'>
                        {_group?.days.map((dd, i) => (<div key={i}>
                            <span>{dd.date} From <b>{dd.starttime}</b> to <b>{dd.endtime}</b></span>
                        </div>))}
                    </div>
                </div>
            )

        } else {
            return ''
        }
    }

    useEffect(() => {
        if (bookingDetail) {
            let filteredStartDates
            if (bookingDetail.byDates === 1) {
                filteredStartDates = bookingDetail.additionalDates.filter(item => bookingDetail.selectedDates.includes(item._id)).map(item => item.startDate);
                setDisableDocsUpload(filteredStartDates.reduce((last, i) => last || isLessThanEquals14Days(i), false))
            } else {
                setDisableDocsUpload(isLessThanEquals14Days(bookingDetail.startDate))
            }
        }
    }, [bookingDetail])

    return (
        <div className="body_container program_page">
            <Modal
                dialogClassName="h_auto"
                show={isViewProducts}
                animation={false}
                size={activeProduct?.storeData?.[0]?.subItems?.length > 0 ? 'xl' : undefined}
                centered>
                <Modal.Body>
                    <div className="">
                        <span className="modal_close" onClick={handleCloseProductModal}><i className="icon-cross" /></span>
                    </div>
                    {activeProduct &&
                        <div className='row'>
                            <div className='col-lg-4 pb-5'>
                                {
                                    activeProduct?.storeData[0]?.image?.length ?
                                        <Slider {...settings}>
                                            {activeProduct?.storeData[0]?.image.map(img => (
                                                <img src={img} className="img-fluid pointer" key={uuidv4()} />
                                            ))}
                                        </Slider> : ''
                                }
                            </div>
                            <div className='col-lg-8'>
                                <div className='product_text'>
                                    <h3 style={{ color: activeProduct?.storeData[0]?.textColor || '#000', marginBottom: '16px' }}>{activeProduct?.storeData[0]?.title}</h3>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <tbody>
                                            {activeProduct?.camperData?.firstName && (
                                                <tr>
                                                    <td style={{ fontWeight: 600, paddingBottom: '10px', paddingRight: '24px', whiteSpace: 'nowrap', verticalAlign: 'top', width: '1%' }}>Camper Name</td>
                                                    <td style={{ paddingBottom: '10px', verticalAlign: 'top' }}>{activeProduct.camperData.firstName} {activeProduct.camperData.lastName}</td>
                                                </tr>
                                            )}
                                            {activeProduct?.selectedColor && (
                                                <tr>
                                                    <td style={{ fontWeight: 600, paddingBottom: '10px', paddingRight: '24px', whiteSpace: 'nowrap', verticalAlign: 'top', width: '1%' }}>Color</td>
                                                    <td style={{ paddingBottom: '10px', verticalAlign: 'top' }}>{activeProduct.selectedColor}</td>
                                                </tr>
                                            )}
                                            {activeProduct?.selectedSize && (
                                                <tr>
                                                    <td style={{ fontWeight: 600, paddingBottom: '10px', paddingRight: '24px', whiteSpace: 'nowrap', verticalAlign: 'top', width: '1%' }}>Size</td>
                                                    <td style={{ paddingBottom: '10px', verticalAlign: 'top' }}>{activeProduct.selectedSize}</td>
                                                </tr>
                                            )}
                                            {activeProduct?.count > 0 && (
                                                <tr>
                                                    <td style={{ fontWeight: 600, paddingBottom: '10px', paddingRight: '24px', whiteSpace: 'nowrap', verticalAlign: 'top', width: '1%' }}>Quantity</td>
                                                    <td style={{ paddingBottom: '10px', verticalAlign: 'top' }}>{activeProduct.count}</td>
                                                </tr>
                                            )}
                                            {activeProduct?.selectedPrice > 0 && (
                                                <tr>
                                                    <td style={{ fontWeight: 600, paddingBottom: '10px', paddingRight: '24px', whiteSpace: 'nowrap', verticalAlign: 'top', width: '1%' }}>Price</td>
                                                    <td style={{ paddingBottom: '10px', verticalAlign: 'top' }}>${activeProduct.selectedPrice.toFixed(2)}</td>
                                                </tr>
                                            )}
                                            {activeProduct?.storeData[0]?.desc && removeHtmlTags(activeProduct.storeData[0].desc).trim() && (
                                                <tr>
                                                    <td style={{ fontWeight: 600, paddingBottom: '10px', paddingRight: '24px', whiteSpace: 'nowrap', verticalAlign: 'top', width: '1%' }}>Description</td>
                                                    <td style={{ paddingBottom: '10px', verticalAlign: 'top' }}>{removeHtmlTags(activeProduct.storeData[0].desc).trim()}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {activeProduct?.storeData[0]?.subItems?.length > 0 &&
                                    <>
                                        <h4>Add-ons</h4>
                                        <div className="d-flex flex-column flex-sm-row flex-wrap align-content-start align-items-stretch">
                                            {activeProduct?.storeData[0]?.subItems?.map((subItem, si) =>
                                                <div className='product_card p-3 me-3' key={uuidv4()}>
                                                    {
                                                        subItem?.image?.length &&
                                                        <img src={subItem.image[0]} className="img-fluid" style={{ width: '120px', height: "120px" }} />

                                                    }
                                                    <div className='product_text'>
                                                        <div style={{ width: '120px' }}>
                                                            <h3 style={{ color: subItem.textColor || '#000' }}>{subItem.title}</h3>
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                            }

                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    }
                </Modal.Body>
            </Modal>
            {loader ? <div className="page_loader"><ProgramLoader /></div> : ''}

            <div className="container booking_detail">

                <div className="qr_code_wrap show_on_print">
                    <h3 className="mb-4">My QR Code</h3>
                    {bookingDetail.qr && bookingDetail.qr.length ? bookingDetail.qr.map(item => (
                        <div className="qr_img" key={item._id}>
                            <img src={item.qrCode} className="img-fluid" alt="" />
                            <h5>{item.camperName}</h5>
                            <h6 className="text-center mt-3">Group code: {item.groupCode ? item.groupCode : 'N/A'}</h6>
                        </div>
                    )) : <div className="no_img"><LogoWhite /></div>
                    }
                </div>

                <div className="d-flex justify-content-between program_head">
                    <div>
                        <h2><img src={bookingDetail.campLogo} alt="" /> {bookingDetail.campName} - {bookingDetail.programName}</h2>
                    </div>
                    <div className="text-center">
                        <div className="ratings">
                            <span>EZPro: </span>
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                        </div>
                        <small>({bookingDetail.ratingCount} reviews)</small>
                    </div>
                </div>


                <div className="row">
                    <div className="col-lg-8 prog_main">

                        <div className="prog_media prog_media_desk hide_on_print">

                            {bookingDetail.programImages?.filter(ll => !ll.viewType)?.length ?
                                <Slider {...settings2}>
                                    {bookingDetail.programImages.filter(i => !i.viewType).map(item => (
                                        <div className="prog_slide_img" key={item._id}>
                                            <img src={item.url || bookingDetail.programImage} className="img-fluid" alt="program" />
                                        </div>
                                    ))}
                                </Slider> :

                                bookingDetail?.programImages?.length ?
                                    <Slider {...settings2}>
                                        {bookingDetail.programImages.map(item => (
                                            <div className="prog_slide_img_secondary" key={item._id}>
                                                <img src={item.url || bookingDetail.programImage} className="img-fluid" alt="program" />
                                            </div>
                                        ))}
                                    </Slider> : bookingDetail.programImage ? <img src={bookingDetail.programImage} className="img-fluid" alt="" />
                                        :
                                        <div className="no_img"><LogoWhite /></div>
                            }

                            <i className={`cm_follow icon-plus ${isFollowed ? 'active' : ''}`} onClick={handleFollow} />

                            <div className="prog_action">
                                <i className={`icon-heart${isFavourite ? '-fill' : ''}`} onClick={handleFavourite} />
                                <Share pageUrl={`Booking=${props.match.params.id}`} />
                            </div>
                        </div>



                        <div className="prog_media prog_media_mob hide_on_print">

                            {bookingDetail?.programImages?.filter(ll => ll.viewType)?.length ?

                                <Slider {...settings2}>
                                    {bookingDetail.programImages.filter(i => i.viewType).map(item => (
                                        <div className="prog_slide_img" key={item._id}>
                                            <img src={item.url || bookingDetail.programImage} className="img-fluid" alt="program" />
                                        </div>
                                    ))}
                                </Slider> :
                                bookingDetail.programImages?.length ?
                                    <Slider {...settings2}>
                                        {bookingDetail.programImages.map(item => (
                                            <div className="prog_slide_img" key={item._id}>
                                                <img src={item.url || bookingDetail.programImage} className="img-fluid" alt="program" />
                                            </div>
                                        ))}
                                    </Slider> : bookingDetail.programImage ? <img src={bookingDetail.programImage} className="img-fluid" alt="program" /> :
                                        <div className="no_img"><LogoWhite /></div>
                            }

                            <i className={`cm_follow icon-plus ${isFollowed ? 'active' : ''}`} onClick={handleFollow} />

                            <div className="prog_action">
                                <i className={`icon-heart${isFavourite ? '-fill' : ''}`} onClick={handleFavourite} />
                                <Share pageUrl={`Booking=${props.match.params.id}`} />
                            </div>
                        </div>



                        <div className={`d-flex justify-content-${bookingDetail.byDates === 1 ? 'end' : 'between'} mt-3 mb-4 prog_d`}>
                            {
                                bookingDetail.byDates === 1 ? '' : <h3>{(() => {
                                        const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
                                        const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                                        const [sy, sm, sd] = (bookingDetail.startDateFormatted || '').split('-').map(Number);
                                        const [ey, em, ed] = (bookingDetail.endDateFormatted || '').split('-').map(Number);
                                        if (!sy) return '';
                                        const sDay = days[new Date(sy, sm - 1, sd).getDay()];
                                        const eDay = days[new Date(ey, em - 1, ed).getDay()];
                                        if (sy === ey && sm === em && sd === ed)
                                            return `${months[sm - 1]} ${sd}, ${sy} (${sDay})`;
                                        return `${months[sm - 1]} ${sd}, ${sy} - ${months[em - 1]} ${ed}, ${ey} ( ${sDay}-${eDay})`;
                                    })()}</h3>
                            }


                            <div className="prog_price">
                                {bookingDetail.byDates === 1 ? (
                                    <h3>{getProgramPriceByDates(bookingDetail.additionalDates, bookingDetail.selectedDates)}</h3>
                                ) : (
                                    <h3>Price : <b>${bookingDetail.registrationFee?.toFixed(2)}</b></h3>
                                )}

                            </div>


                        </div>




                        <h3>Booking Information</h3>

                        <div className="bkng_info row mt-4">
                            <div className="col-md-6">
                                <p><b>Booking date: </b>{moment.utc(bookingDetail.bookingDate).format('DD MMMM, YYYY')}</p>

                                {
                                    bookingDetail.byDates === 1 ? (
                                        <p><b>Program dates: </b><br />{getSelectedDates(bookingDetail.additionalDates, bookingDetail.selectedDates)}</p>

                                    ) : (
                                        <p><b>Program dates: </b> {campDates(bookingDetail.startDate, bookingDetail.endDate)}</p>
                                    )
                                }





                                <p><b>Program Name: </b>{bookingDetail.programName}</p>
                            </div>
                            <div className="col-md-6">
                                <p><b>Booking Number: </b>{bookingDetail.bookingNumber}</p>
                            </div>
                        </div>



                        <h3>Program Details</h3>

                        <div className="pro_details row mt-4">
                            <div className="col-md-6 cm_bor_right">
                                {bookingDetail.districtName ? <p><b>District Name: </b>{bookingDetail.districtName}</p> : ''}
                                <p><b>Programs: </b>{bookingDetail.programName}</p>
                                <p><b>Age Group: </b>{bookingDetail.ageGroup}</p>
                                <p><b>Sex: </b>{bookingDetail.gender === 1 ? 'Male' : ''}
                                    {bookingDetail.gender === 2 ? 'Female' : ''}
                                    {bookingDetail.gender === 3 ? 'Co-Ed' : ''}</p>
                                <p className="last_dot"><b>Grade: </b>{bookingDetail.grade && gradeArr2.filter(el => bookingDetail.grade.find(e => el.value === e)).sort((a, b) => a.count - b.count).map(item => <Fragment key={item.value}>{item.value}<span>,</span> </Fragment>)}</p>
                                <p className="last_dot"><b>Meals Provided: </b>{bookingDetail.meals && bookingDetail.meals.length ? bookingDetail.meals.map(item => <Fragment key={item}>{item ? item : 'None'}<span>,</span> </Fragment>) : 'None'}</p>
                                <p><b>Check in Time: </b>{bookingDetail.checkInTime}</p>
                                <p><b>Check out Time: </b>{bookingDetail.checkOutTime}</p>
                            </div>
                            <div className="col-md-6">
                                <p><b>Type: </b>{bookingDetail.programType ? getProgramType(bookingDetail.programType) : 'N/A'}</p>
                                <p><b>Aftercare Available: </b>{bookingDetail.afterCare ? 'Yes' : 'No'}</p>
                                <p><b>Experience: </b>{bookingDetail.expLevel ? getExperience(bookingDetail.expLevel) : 'N/A'}</p>
                                <p><b>Travel: </b>{getTravel(bookingDetail.travel) || 'N/A'}</p>
                                <p><b>T-Shirt: </b>{getTshirt(bookingDetail.tShirt) || 'N/A'}</p>
                                <p><b>Program Code: </b>{bookingDetail.programCode}</p>
                            </div>
                        </div>



                        <div className="sm_section mt-5">
                            <h3>Instruction, Equipment & Facility</h3>
                            <ul>
                                <li>Instruction :<p className="ps-4">{getHtml(bookingDetail.programInstruction || 'N/A')}</p></li>
                                <li>Equipment Needed : <p className="ps-4">{bookingDetail.equipment || 'N/A'}</p></li>
                                <li>Facility : <p className="ps-4">{bookingDetail.facility ? getFacility(bookingDetail.facility) : 'N/A'}</p></li>
                            </ul>
                        </div>

                        <div className="sm_section">
                            <h3 className="mb-3">Important Notes</h3>
                            <p>{bookingDetail.impNotes ? getHtml(bookingDetail.impNotes) : 'N/A'}</p>
                        </div>


                        {TRAVEL_NEEDS_INFO.includes(bookingDetail.travel) ?
                            <div className="sm_section">
                                <h3 className="mb-3">Travel Info</h3>
                                <p>{bookingDetail.travelInfo ? getHtml(bookingDetail.travelInfo) : 'N/A'}</p>
                            </div> : ''
                        }

                        {campers.length ? campers[0].additionalExperience.length ? <div className="sm_section">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="mb-0">Additional Experience</h3>

                                {/* <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={handleAddAdditionalExperience}
                                >
                                    Add Additional Experience
                                </button> */}
                            </div>
                            {
                                campers.map(item => <div className="">{item.additionalExperience.map(addit => <div className="cm_addit">
                                    <p><b>Title</b></p>
                                    <p>{getHtml(addit.title)}</p>
                                    <p><b>Number Purchased:</b> {addit.numberOfBooking}</p>
                                    <p><b>price:</b> ${parseInt(addit.price).toFixed(2)}</p>
                                </div>)}</div>)
                            }
                        </div> : '' : ''}


                        <Row >

                            {bookingDetail?.purchaseData?.length ? <div className='col-12 d-flex justify-content-between align-items-center mb-2'>
                                <h3 className='mb-0'>Products</h3>
                                <Dropdown>
                                    <Dropdown.Toggle variant='outline-secondary' size='sm'>
                                        {{ 1: 'Active', 2: 'canceled', 3: 'canceled and Refunded', 4: 'Refunded' }[productFilter]}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {[{ v: 1, l: 'Active' }, { v: 2, l: 'canceled' }, { v: 3, l: 'canceled and Refunded' }, { v: 4, l: 'Refunded' }]
                                            .filter(opt => opt.v !== productFilter)
                                            .map(opt => <Dropdown.Item key={opt.v} onClick={() => setProductFilter(opt.v)}>{opt.l}</Dropdown.Item>)
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div> : ''}



                            {
                                bookingDetail?.purchaseData?.length ? (() => {
                                    const flatItems = (bookingDetail.purchaseInfo || []).flatMap(purchase =>
                                        (purchase.items || []).map(item => ({ item, purchase }))
                                    );
                                    return bookingDetail.purchaseData.map((pp, index) => {
                                    if (!pp?.storeData) return null;
                                    const { item: matchedItem, purchase: matchedPurchase } = flatItems[index] || {};
                                    const itemStatus = matchedItem?.itemStatus;
                                    if (itemStatus !== productFilter) return null;
                                    const borderColor = { 2: '#ef4444', 3: '#f97316', 4: '#3b82f6' }[itemStatus] || 'transparent';
                                    return (
                                        <>
                                            <Col xl={3} lg={4} md={4} sm ={6} className='font13'>
                                                <div  key={uuidv4()}>
                                                    <div className='product_card' style={{width:'200px', border: `2px solid ${borderColor}`, borderRadius: '8px'}}>
                                                        {
                                                            pp?.storeData[0]?.image?.length ? <Slider {...settings}>
                                                                {pp?.storeData[0]?.image.map(img => (
                                                                    <div>
                                                                        <img src={img} className="img-fluid pointer" alt="" />
                                                                    </div>
                                                                ))}
                                                            </Slider> : ''
                                                        }


                                                        <div className='product_text'>
                                                            <h3 style={{ color: pp?.storeData[0]?.textColor || '#000' }}>{pp?.storeData[0]?.title}</h3>
                                                            {pp?.camperData?.firstName && <p><b>Camper Name:</b> {pp?.camperData?.firstName} {pp?.camperData?.lastName}</p>}
                                                            <div className='d-flex justify-content-between align-items-center mb-3'>
                                                                {pp?.totalPrice && <p><b>Total Price:</b> {pp?.totalPrice}</p>}
                                                                {matchedPurchase?.payment?.status === 3 ? <span className='p_cat_text' style={{ background: 'red' }}>Failed Payment</span> : ''}
                                                            </div>
                                                            <button type="button" className="btn btn-light" onClick={() => showProductInfo(pp, matchedItem)}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                                                </svg>
                                                                <span className='ms-2'><i>Product info</i></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </>
                                    );
                                    });
                                })() : ''
                            }

                        </Row>

                    </div>


                    <div className="col-lg-4">

                        <h3 className="hide_on_print">My QR Code</h3>
                        <div className="qr_code_wrap hide_on_print">
                            {bookingDetail.qr && bookingDetail.qr.length ? <Slider {...settings}>
                                {bookingDetail.qr.map(item => (
                                    <div className="qr_img" key={item._id}>
                                        <img src={item.qrCode} className="img-fluid" alt="" />
                                        <h5>{item.camperName}</h5>
                                        <h6 className="text-center mt-3">Group code: {item.groupCode ? item.groupCode : 'N/A'}</h6>
                                    </div>
                                ))}
                            </Slider> : <div className="no_img"><LogoWhite /></div>
                            }
                        </div>


                        <Modal
                            show={activeForm.camperId}
                            centered
                            size='xl'
                            dialogClassName="remove_header_line">

                            <Modal.Header>
                                <span className="modal_close" onClick={() => setActiveForm({})}><i className="icon-cross" /></span>
                            </Modal.Header>
                            <Modal.Body>
                                <div className='embed_div'>
                                    <PdfViewer fileUrl={activeForm.url} />
                                </div>




                                <div className="d-flex mt-3">
                                    <button onClick={() => setActiveForm({})} className="btn btn-dark w-100">Cancel</button>
                                    {
                                        activeForm.viewType ? '' : <button onClick={updateBookingKey} className="btn btn-primary w-100 ms-3">I Agree</button>
                                    }

                                </div>

                            </Modal.Body>
                        </Modal>

                        <div>
                            <Link to={`/online-store`}>
                                <Container>
                                    <Row className="justify-content-center">
                                        <Col xs={12} md={8} lg={12}>
                                            <img
                                                src={buttonGif}
                                                alt="Loading..."
                                                className="img-fluid"
                                            />
                                        </Col>
                                    </Row>
                                </Container>
                            </Link>
                            <div className="d-flex justify-content-end mt-3 me-5 pe-4">
                                <button
                                className="btn btn-outline-primary btn-lg px-3"
                                onClick={handleAddAdditionalExperience}
                                >
                                Add Additional Experience
                                </button>
                            </div>
                        </div>

                        {!showCamperForms && (
                            <div className="cta-spacer" />
                        )}

                        {showCamperForms &&
                            <ul className="booking_users booking_users2">
                                {
                                    campers.filter(camperHasEntry).map((item, inde) => {
                                        const applies = getApplicableDocuments(bookingDetail, item);
                                        return (
                                        <li key={inde}>
                                            {disableDocsUpload && <p style={{ fontSize: "0.85rem" }} className="text-danger mb-3">Note: Online Form uploads and online store purchases are no longer available. Please bring any incomplete forms with you to check-in. Store items are available at check-in as well. </p>}
                                            <h6>{item.camperName}</h6>

                                            {
                                                !applies.keyDeposit ? '' : (
                                                    <div className='get_forms'>
                                                        <p>Key Deposit</p>
                                                        {item.keyDeposit ?
                                                            <span
                                                                onClick={() => setActiveForm({ viewType: true, camperId: item.camperId, type: 'keyDeposit', url: require('../../assets/pdf/key-deposit.pdf') })}
                                                                className="updated_icon"><img src={require('../../assets/img/check_icon.png')}
                                                                    alt="" /> Updated</span>
                                                            :
                                                            disableDocsUpload ? '' :
                                                                <span
                                                                    className={`btn btn-secondary btn-sm`}
                                                                    onClick={() => setActiveForm({ camperId: item.camperId, type: 'keyDeposit', url: require('../../assets/pdf/key-deposit.pdf') })}
                                                                >View</span>}
                                                    </div>
                                                )
                                            }

                                            {applies.concussion && <div className='get_forms'>
                                                <p>Concussion Waiver Document </p>
                                                {item.concussion ?
                                                    <span
                                                        onClick={() => setActiveForm({ viewType: true, camperId: item.camperId, type: 'concussion', url: require('../../assets/pdf/concussion-protocol.pdf') })}
                                                        className="updated_icon ">
                                                        <img src={require('../../assets/img/check_icon.png')} alt="" />
                                                        Updated
                                                    </span>
                                                    :
                                                    disableDocsUpload ? '' :
                                                        <span
                                                            onClick={() => setActiveForm({ camperId: item.camperId, type: 'concussion', url: require('../../assets/pdf/concussion-protocol.pdf') })}
                                                            className={`btn btn-secondary btn-sm`}>
                                                            View
                                                        </span>}
                                            </div>}

                                            {applies.medicalClearance && <div className='get_forms'>
                                                <p>Attach medical clearance form & physical </p>
                                                {disableDocsUpload ? '' :
                                                    getMedicalDocumentUrl(item?.medicalDocument) ?
                                                        <span className={"btn btn-outline-secondary btn-sm"} style={{ position: 'relative' }}>
                                                            Add more
                                                            <input type='File' onChange={e => handleFileChange(e, item.camperId)} className='mm_file' />
                                                        </span>
                                                        :
                                                        <span className={"btn btn-outline-secondary btn-sm"} style={{ position: 'relative' }}>
                                                            Attach PDF
                                                            <input type='File' onChange={e => handleFileChange(e, item.camperId)} className='mm_file' />
                                                        </span>
                                                }
                                            </div>}
                                            {applies.medicalClearance && item?.medicalDocument?.length > 0 &&
                                                item?.medicalDocument.filter(i => i).map((url, i) =>
                                                    <p
                                                        className="updated_icon"
                                                        onClick={() => setActiveForm({ viewType: true, camperId: item.camperId, type: 'concussion', url: url })}
                                                    >
                                                        <img src={require('../../assets/img/check_icon.png')} alt="" />
                                                        <small>Medical Document {i + 1}</small>
                                                    </p>
                                                ).reverse()

                                            }


                                            {getAgeGroupsOfBooking(item.camplistid, bookingDetail.agegroups)}


                                        </li>
                                        );
                                    })
                                }
                            </ul>}

                        <div className='waiver_disclaimer'>
                            <p>Waiver Disclaimer</p>
                            {bookingDetail.isDisclaimer ?
                                <span onClick={() => setActiveForm({ viewType: true, camperId: 'isDisclaimer', type: 'isDisclaimer', url: require('../../assets/pdf/Waiver-disc.pdf') })} className="updated_icon"><img src={require('../../assets/img/check_icon.png')} alt="" /> Updated</span>
                                :
                                disableDocsUpload ? '' :
                                    <span className="btn btn-outline-secondary btn-sm" onClick={() => setActiveForm({ camperId: 'isDisclaimer', type: 'isDisclaimer', url: require('../../assets/pdf/Waiver-disc.pdf') })}>View </span>

                            }
                        </div>
                        {
                            // The template is Sports International's own form, so it stays SI-only.
                            setting.api.sportInternationalCamp === bookingDetail.campId && getApplicableDocuments(bookingDetail).medicalClearance ? <div className='d-flex justify-content-center mb-5'>
                                <a className='btn btn-primary' download href={require('../../assets/pdf/Medical-Clearance-Form.docx')}>Download Medical Clearance Form</a>
                            </div> : ''
                        }


                        {bookingDetail.isOnline ?
                            (<h2 className="cm_on_line">Online Program</h2>)
                            :
                            (<div className="camp_detail_map">
                                {bookingDetail.geoLocation ? <MapComponent geoLocation={bookingDetail.geoLocation} {...props} /> : ''}
                                <div className="camp_detail_address">
                                    {bookingDetail.city ? <p className="m-0">{`${bookingDetail.addressLine1} ${bookingDetail.city} ${bookingDetail.state}`}</p> : ''}
                                </div>
                            </div>)}
                        {
                            bookingDetail.packingList ? <div className="text-center hide_on_print">
                                <a href={bookingDetail.packingList} download className="btn btn-primary rounded-0 ps-4 pe-4"><i className="icon-doc-check" /> Download Packing List</a>
                            </div> : ''
                        }


                        <div className="text-center mt-3 hide_on_print">
                            <button onClick={handlePrint} className="btn btn-sm btn-primary rounded-0 ps-4 pe-4"><i className="icon-print" /> Print</button>
                        </div>





                        <h3 className="mt-4">Schedule</h3>
                        <div className="daily_schedule mb-4">
                            <ul>{bookingDetail.schedule && bookingDetail.schedule.length ? bookingDetail.schedule.map(item => (
                                <li key={item._id}><b>{item.time}</b> {item.activity}</li>
                            )) : <li>Not updated</li>}
                            </ul>

                        </div>

                        <h3>Price Details</h3>
                        <div className="p_detail_wrap">

                            <ul className="booking_users">
                                {campers.map((item, inde) => <li key={inde}>
                                    {item.status === 2 ? <span className='book_status'>canceled</span> : ''}
                                    {item.status === 3 ? <span className='book_status'>Refunded</span> : ''}

                                    {pdfLoader ? <div className="upload_loader"><UploadLoader /></div> : <OverlayTrigger
                                        key={item.camperId}
                                        delay={{ show: 10, hide: 200 }}
                                        overlay={<Tooltip className="dark_tooltip">Upload PDF</Tooltip>}>

                                        <div className="cm_upload_pdf"><i className="icon-upload" /><input type="file" value="" onChange={e => handleFileUpload(e, item.camperId)} accept="application/pdf" /></div>

                                    </OverlayTrigger>}



                                    <h6>{item.camperName}</h6>
                                    {item.gardianPdf ? <div className="gardianPdf"><a target="_blank" href={item.gardianPdf} rel="noopener noreferrer"><PDFIcon /> PDF Uploaded</a></div> : ''}



                                    <div className="d-flex justify-content-between">
                                        <span>Program Cost: </span>
                                        {/* campRegistrationFee, not programCost: the latter is stored gross of the
                                            camper's add-ons and net of the discount, so pairing it with the
                                            Additional Experience and Discount lines below counted both twice and the
                                            lines stopped adding up to the Grand Total. */}
                                        {bookingDetail.byDates === 1 ? <b>${getProgramPriceByDates2(bookingDetail.additionalDates, bookingDetail.selectedDates)}</b> : <b>${getProgramCostLine(item, bookingDetail).toFixed(2)}</b>}
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <span>Convenience Fee: </span>
                                        <b>${bookingDetail.convenienceFee.toFixed(2)}</b>
                                    </div>
                                    {/* Part of the Grand Total, so it has to appear here too. */}
                                    {bookingDetail.registerNonRefundFee ? (
                                        <div className="d-flex justify-content-between">
                                            <span>Non-refundable Fee: </span>
                                            <b>${bookingDetail.registerNonRefundFee.toFixed(2)}</b>
                                        </div>
                                    ) : ''}
                                    {
                                        item.additionalExperience.length ? (
                                            <div className="d-flex justify-content-between">
                                                <span>Additional Experience: </span>
                                                <b>${(item.additionalExperience[0].price * item.additionalExperience.length).toFixed(2)}</b>
                                            </div>
                                        ) : ''
                                    }

                                    {item.discountPrice ? (
                                        <div className="d-flex justify-content-between">
                                            <span>Discount: </span>
                                            <b>- ${item.discountPrice?.toFixed(2)}</b>
                                        </div>
                                    ) : ''}

                                </li>)}
                            </ul>





                            <div className="d-flex justify-content-between gt_total">
                                <span>Grand Total : </span>
                                {bookingDetail.byDates === 1 ? <b>${getProgramPriceByDates2(bookingDetail.additionalDates, bookingDetail.selectedDates)}</b> : <b>${bookingDetail?.registrationFee?.toFixed(2)}</b>}
                            </div>

                            {
                                bookingDetail.insurance ? <div className="d-flex justify-content-between gt_total">
                                    <span>Insurance : </span>
                                    <b>${bookingDetail?.insurance?.toFixed(2)}</b>
                                </div> : ''
                            }
                            {checkCancelStatus(bookingDetail?.campers) ? <div className="text-center hide_on_print">
                                <button className="btn btn-primary rounded-0" onClick={() => setCancelModal(true)}>Cancel Booking</button>
                            </div> : ''}

                        </div>



                    </div>
                </div>


                {
                    bookingDetail?.isReview === 2 ? '' : todayDate < bookingDetail.startDate ? '' : <div className="review_sec">
                        <img src={require('../../assets/img/logo.svg')} alt="" />
                        <h6>Rate your camp experience</h6>

                        {
                            reviewSuccess ?
                                <p>Review submitted successfully</p>
                                :
                                <>
                                    <p>If you  have specific feedback, please let us know below</p>
                                    <Rate value={rating} onChange={e => setRating(e)} />

                                    <textarea
                                        className={`form-control ${reviewError ? 'is-invalid' : ''}`}
                                        placeholder="Message"
                                        value={reviewText}
                                        onChange={e => (setReviewText(e.target.value), setReviewError(false))} />

                                    <div className="text-center cm_round_btn mt-4">
                                        <button onClick={() => submitReview(bookingDetail.campId)} className="btn btn-primary ps-4 pe-4">Submit</button>
                                    </div>
                                </>
                        }
                    </div>
                }






            </div>



            <Modal
                show={cancelModal}
                centered
                size='lg'
                dialogClassName="remove_header_line cxp-booking-dialog">

                <Modal.Header>
                    <h3>Cancel Booking</h3>
                    <span className="modal_close" onClick={closeModal}><i className="icon-cross" /></span>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-4 cancel_policy">

                        <CancellationPolicyCards
                            item={bookingDetail}
                            insurancePurchased={hasCancellationInsurance(campers)}
                            className="cxp-embedded" />

                        <p><b>Please select participent which you want remove from booking</b></p>
                        <ul className="booking_users ps-0">
                            {campers.map(item => <li key={item.camperId} className={`by_cancel_camper_list ${item.status === 2 || item.status === 3 ? 'd-none' : ''}`}>

                                <div className="check_box_wrapper cm_dark_check mb-3">
                                    <input
                                        name='participents'
                                        checked={selectedCamperForCancelBooking.includes(item.camperId)}
                                        onChange={() => handleCancelCamperSelect(item.camperId)}
                                        type="checkbox" />
                                    <span className="check_box"><span></span></span>
                                </div>

                                <h6>{item.camperName}</h6>
                                {item.gardianPdf ? <div className="gardianPdf"><a target="_blank" href={item.gardianPdf} rel="noopener noreferrer"><PDFIcon /> PDF Uploaded</a></div> : ''}

                                <div className="d-flex justify-content-between">
                                    <span>Program Cost: </span>
                                    {/* campRegistrationFee, not programCost: the latter is stored gross of the
                                        camper's add-ons and net of the discount, so pairing it with the
                                        Additional Experience and Discount lines below counted both twice and the
                                        lines stopped adding up to the Grand Total. */}
                                    {bookingDetail.byDates === 1 ? <b>${getProgramPriceByDates2(bookingDetail.additionalDates, bookingDetail.selectedDates)}</b> : <b>${getProgramCostLine(item, bookingDetail).toFixed(2)}</b>}
                                </div>

                                <div className="d-flex justify-content-between">
                                    <span>Convenience Fee: </span>
                                    <b>${bookingDetail.convenienceFee.toFixed(2)}</b>
                                </div>
                                {/* Part of the Grand Total, so it has to appear here too. */}
                                {bookingDetail.registerNonRefundFee ? (
                                    <div className="d-flex justify-content-between">
                                        <span>Non-refundable Fee: </span>
                                        <b>${bookingDetail.registerNonRefundFee.toFixed(2)}</b>
                                    </div>
                                ) : ''}
                                {
                                    item.additionalExperience.length ? (
                                        <div className="d-flex justify-content-between">
                                            <span>Additional Experience: </span>
                                            <b>${(item.additionalExperience[0].price * item.additionalExperience.length).toFixed(2)}</b>
                                        </div>
                                    ) : ''
                                }

                                {item.discountPrice ? (
                                    <div className="d-flex justify-content-between">
                                        <span>Discount: </span>
                                        <b>- ${item.discountPrice?.toFixed(2)}</b>
                                    </div>
                                ) : ''}

                            </li>)}
                        </ul>


                        <div className="cxp cxp-cancel-footer">
                            <label className="check_box_wrapper cm_dark_check cxp-ack">
                                <input
                                    type="checkbox"
                                    checked={cancelAcknowledged}
                                    onChange={e => setCancelAcknowledged(e.target.checked)} />
                                <span className="check_box"><span></span></span>
                                <span>I acknowledge that I am canceling my camper's registration and understand the cancellation policy outlined above.</span>
                            </label>
                            <div className="cxp-cancel-actions">
                                <button type="button" className="btn btn-outline-dark" onClick={closeModal}>Keep Booking</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!cancelAcknowledged || !selectedCamperForCancelBooking.length || cancelBookingLoader}
                                    onClick={handleBookingCancel}>
                                    Cancel Booking
                                </button>
                            </div>
                        </div>




                    </div>

                </Modal.Body>
            </Modal>

        </div>
    )
}


const mapStateToProps = state => {
    let { userProfile } = state.user;
    return {
        userProfile
    }
}

export default connect(mapStateToProps)(ViewBooking);